import React from 'react';

import utils from '../utils';
import MainAppBarSelected from './MainAppBarSelected';
import MainAppBarInactive from './MainAppBarInactive';
import MainAppBarSearch from './MainAppBarSearch';


const rootStyle = {
  /*position: 'relative',*/
  position: 'fixed',
  top: 0,
  width: '100%',
  height: 54,
  zIndex: 2,
};


export default class MainAppBar extends React.Component {

  onAction(payload) {
    const { onAction } = this.props;
    const hyphen = utils.hyphenToCamel('on-' + payload.target);
    const handler = this.props[hyphen];
    if (handler) {
      handler(payload);
    }
    if (onAction) {
      onAction(payload);
    }
  }

  render() {
    const { layout, actions, selected, feed } = this.props;
    const rootBgColor = layout === 'selected' ? '#4D5E99' : '#1AC6FF';
    let component = null;
    switch(layout) {
      case 'selected':
        component = (
          <MainAppBarSelected
            actions={actions}
            selected={selected}
            onAction={p => {this.onAction(p)}}
          />
        );
        break;
      case 'search':
        component = (<MainAppBarSearch
          onAction={p => {this.onAction(p)}}
        />);
        break;
      default:
        component = (<MainAppBarInactive
          feed={feed}
          onAction={p => {this.onAction(p)}}
        />);
        break;
    }
    return (
      <div
        style={{...rootStyle, background: rootBgColor}}
        onTouchTap={e => {
          // must prevent event from emit to parent
          // so parent can hook on his events ONLY
          e.stopPropagation();
          e.preventDefault();
          e.nativeEvent.stopImmediatePropagation();
        }}
      >
        {component}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/MainAppBar/MainAppBar.jsx